import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import {
    TDirectoryServiceError,
    TPaymentStatusesResponse,
} from 'services/DirectoryService'
import { QueryCacheKeys } from 'enums'
import { DirectoryService } from 'services'
import { getRequestError } from 'utils/helpers'

export type TQueryFnOpts = UseQueryOptions<
    TPaymentStatusesResponse,
    [string, AxiosError<TDirectoryServiceError, never>],
    TPaymentStatusesResponse,
    [string]
>

const key = QueryCacheKeys.paymentStatuses

/**
 * Hook API payment statuses
 */
export default function useFetchPaymentStatuses(opts: TQueryFnOpts = {}) {
    const { t } = useTranslation()

    return useQuery([key], () => {
        return DirectoryService.fetchPaymentStatuses()
            .then(({ data }) => {
                return data
            })
            .catch((err) => {
                return Promise.reject([getRequestError(err) || t('update_error'), err])
            })
    }, opts)
}
